import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { IActivity, IDropdown } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { IOpenForm } from "./Activity";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { AutoComplete } from "primereact/autocomplete";
import { Dropdown } from "primereact/dropdown";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {
    const [cities, setCities] = useState<IDropdown[]>();
    const [selectedCity, setSelectedCity] = useState<IDropdown>();
    const [activityTypes, setActivityTypes] = useState<IDropdown[]>();
    const [activityTypeId, setActivityTypeId] = useState(0);

    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: IActivity[], count: number, loading: boolean });
    const [text, setText] = useState<string | null>(null);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: 1
    });

    useEffect(() => {
        loadTableData();
    }, [activityTypeId, selectedCity, text, lazyParams, props.reload]);

    async function onCitySearch(text: string) {
        const response = await Fetch(`city/search`, "GET", null, `text=${text}`, null);
        if (response) {
            setCities(await response.json());
        }
    }

    const loadActivityTypes = async () => {
        const response = await Fetch(`activityType/dropdown`, "GET", null, null, null);
        if (response) {
            const d = await response.json();
            d.unshift({ id: 0, name: 'N/A' });
            setActivityTypes(d);
        }
    }
    useEffect(() => {
        loadActivityTypes();
    }, []);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch("activity", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}${text ? '&text=' + text : ''}&activityTypeId=${activityTypeId}&cityId=${selectedCity?.id ?? 0}`, props.toast);
        if (response) {
            const data: { activities: IActivity[], count: number } = await response.json();
            setTableData({ data: data.activities, count: data.count, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: { isActive: true } });
    };

    const openEdit = (rd: IActivity) => {
        const city = { id: rd.cityId, name: rd.location ?? '' };
        const activityTypeId = rd.activityTypeId ?? 0;
        props.setModal({ open: true, singleData: { ...rd, city: city, activityTypeId: activityTypeId } });
    };

    const Remove = async (rowData: IActivity) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`activity/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Activity Deleted", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: IActivity) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.name}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                {props.hasPermission("Activity", "Add") && (
                    <Button style={{ width: '80px', height: '30px' }} label="New" icon="pi pi-plus" className="p-button-sm p-button-rounded p-button-success" onClick={openNew} />
                )}
                <div className="w-full flex align-items-center justify-content-center">
                    <div className="w-full flex align-items-center justify-content-center">
                        <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>Activity</h4>
                        <span style={{ margin: '0 10px' }} >City : </span>
                        <AutoComplete field="name" value={selectedCity} suggestions={cities} completeMethod={(e) => onCitySearch(e.query)} onChange={(e) => setSelectedCity(e.value)} />
                        <span style={{ margin: '0 10px' }} >ActivityType : </span>
                        <Dropdown value={activityTypeId} options={activityTypes} optionLabel="name" optionValue="id" onChange={(e) => setActivityTypeId(e.value)} />
                    </div>
                </div>
            </div>
            <div className="flex gap-4">
                <div className="p-input-icon-left">
                    <Search setSearch={setText} />
                </div>
                {props.hasPermission("Activity", "Export") && (
                    <Button style={{ width: '80px', height: '30px' }} label="Export" icon="pi pi-upload" className="p-button-sm p-button-rounded p-button-help" onClick={exportCSV} />
                )}
            </div>
        </div>
    );


    const actionBodyTemplate = (rowData: IActivity) => {
        return (
            <div className="actions">
                {props.hasPermission("Activity", "Edit") && <Button icon="pi pi-pencil" className='p-button-success p-button-text p-0' onClick={() => openEdit(rowData)} />}
                {props.hasPermission("Activity", "Remove") && <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }}  ></Button>}
            </div>
        );
    };
    const toggleStatus = async (id: number) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`activity/toggleStatus/${id}`, "PUT", null, null, props.toast);
        if (response) {
            setTableData(prev => ({ ...prev, loading: false, data: prev.data.map(d => d.id === id ? { ...d, isActive: !d.isActive } : d) }));
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }
    const statusBody = (rowData: IActivity) => {
        return (
            <div className="flex align-items-center gap-2">
                <i className={`pi ${rowData.isActive ? 'pi-check-circle' : 'pi-times-circle'}`} style={{ color: rowData.isActive ? '#4caf50' : '#f44336' }}></i>
                <span onClick={() => { if (rowData.id) toggleStatus(rowData.id) }} className="cursor-pointer">{rowData.isActive ? 'Active' : 'Disable'}</span>
            </div>
        );
    }
    // const durationBody = (rowData: IActivity) => {
    //     const duration = rowData.duration ?? 0;
    //     const hour = Math.floor(duration / 60);
    //     const minute = duration % 60;
    //     return (
    //         hour && minute ? <span>{`${hour} Hour & ${minute} Minutes`}</span>
    //             : hour ? <span>{hour} Hour</span> : <span>{minute} Minutes</span>
    //     );
    // }

    const activityDetails = (fixedOnly: boolean) => {
        if (fixedOnly) {
            return ['Occupancy', 'Price']?.map(header => (
                <Column key={header} field={header} header={header}
                    body={(r: IActivity) => {
                        const paramval = r.paramsValue?.find(p => p.paramName === header);
                        return <span>{paramval?.value}</span>;
                    }}
                />
            ));
        }
        const headers = tableData.data[0]?.paramsValue?.map(p => p.paramName ?? '');
        return headers?.map(header => (
            <Column key={header} field={header} header={header}
                body={(r: IActivity) => {
                    const paramval = r.paramsValue?.find(p => p.paramName === header);
                    return <span>{paramval?.value}</span>;
                }}
            />
        ));
    }

    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="location" header="Destination" />
                <Column field="name" header="Activity Name" sortable />
                <Column field="isActive" header="Status" sortable body={statusBody} />
                {activityTypeId ? activityDetails(false) : activityDetails(true)}
                <Column field="activityTypeName" header="ActivityType" />
                <Column field="desc" header="Desc" />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <ConfirmDialog />
        </>
    );
}